export const UPSELLING_TARGETS = {
  VARIANTS: 'variants',
  PROMOS: 'promos'
};
